import { default as localeCustomizations } from './locales'
import { default as containerCustomizations } from './customizations'
import { IPartnerConfig } from '../../internal'

import logoLightMode from './assets/blue-key-logo.png';
import logoDarkMode from './assets/blue-key-logo-dark-mode.png';

const partnerCustomizations: IPartnerConfig = {
  assets: {
    logoOnBackground: logoLightMode,
    logoOnSecondary: logoLightMode,
    logoOnPrimary: logoLightMode,
    logoOnDark: logoDarkMode
  },
  locales: localeCustomizations,
  containers: containerCustomizations,
}
export default partnerCustomizations;